import { Injectable } from '@angular/core';
import {HttpEvent, HttpResponse} from "@angular/common/http";
import {ResponseHandlerInterface} from "../models/ResponseHandlerInterface";

@Injectable()
export class JsonapiHandlerService implements ResponseHandlerInterface {

  constructor() { }

  public handle(originalEvent: HttpResponse<any>): HttpEvent<any> {

    let eventClone: HttpEvent<any>;
    const statusCode: number = (originalEvent.status / 100); // first digit of status code

    if (statusCode === 2) {

      // per JSONAPI standard, only data and meta can possibly be in the response payload
      // at the same time. If errors occur, then the response should never be a 200

      const hasData: boolean = (originalEvent.body.hasOwnProperty('data'));
      const hasMeta: boolean = (originalEvent.body.hasOwnProperty('meta'));

      if (hasData && !hasMeta) {
        const data = originalEvent.body.data;
        eventClone = originalEvent.clone({
          body: data
        });
      }
      // pass through original request for all other payloads. This will allow meta to be used along with data
    } else if (statusCode === 4) {
      console.log("JSONAPI Handler >> Status Code(%i) >>", statusCode, event);
    } else if (statusCode === 5) {

      // per JSONAPI standard, if an error or errors occur with the request, then the
      // response can only have 'errors'. It is always plural as it is always an array, even
      // if only one error message is provided.

      const hasErrors: boolean = (originalEvent.body.hasOwnProperty('errors'));

      if (hasErrors) {
        eventClone = originalEvent.clone({
          body: originalEvent.body.errors
        });
      }

    } else { // this shouldn't ever get here. Proper status codes are always greater than or equal to 100 and less than 600
      console.error("JSONAPI Handler >> Invalid Status Code(%i) >> ", statusCode, event);
    }

    return eventClone || originalEvent; // pass through original event if eventClone is null/undefined

  }

}
